import { useCallback, useMemo } from 'react';
import { emitAck } from '../adminEmit';

export function useAdminStatsApi(socket) {
  const wrap = useCallback(
    (event) => (params) => emitAck(socket, event, params),
    [socket]
  );

  const getOverview = useMemo(() => wrap('admin:stats:overview'), [wrap]);
  const getTimeSeries = useMemo(() => wrap('admin:stats:timeseries'), [wrap]);
  const getRequestsByType = useMemo(() => wrap('admin:stats:requests_by_type'), [wrap]);
  const getRequestsByStatus = useMemo(() => wrap('admin:stats:requests_by_status'), [wrap]);
  const getPipelineStages = useMemo(() => wrap('admin:stats:pipeline_stages'), [wrap]);
  const getAuditByType = useMemo(() => wrap('admin:stats:audit_by_type'), [wrap]);
  const getPeakHours = useMemo(() => wrap('admin:stats:peak_hours'), [wrap]);
  const getTopUsers = useMemo(() => wrap('admin:stats:top_users'), [wrap]);
  const getRecentActivity = useMemo(() => wrap('admin:stats:recent_activity'), [wrap]);
  const getFiltersMeta = useMemo(() => () => emitAck(socket, 'admin:stats:filters_meta'), [socket]);
  const getActivityTimeline = useMemo(() => wrap('admin:stats:activity_timeline'), [wrap]);
  const getUsersWorkSummary = useMemo(() => wrap('admin:stats:users_work_summary'), [wrap]);
  const getRequestsByTypeTimeSeries = useMemo(
    () => wrap('admin:stats:requests_by_type_timeseries'),
    [wrap]
  );
  const getRequestDurations = useMemo(() => wrap('admin:stats:request_durations'), [wrap]);
  const getPeakLoad = useMemo(() => wrap('admin:stats:peak_load'), [wrap]);
  const getErrorsRecent = useMemo(() => wrap('admin:stats:errors_recent'), [wrap]);
  const getDowntime = useMemo(() => wrap('admin:stats:downtime'), [wrap]);
  const getWorkOverview = useMemo(() => wrap('admin:stats:work_overview'), [wrap]);
  const getPendingAged = useMemo(() => wrap('admin:stats:pending_aged'), [wrap]);
  const getDailyActivity = useMemo(() => wrap('admin:stats:daily_activity'), [wrap]);
  const getSessionsDetail = useMemo(() => wrap('admin:stats:sessions_detail'), [wrap]);

  return useMemo(
    () => ({
      getOverview,
      getTimeSeries,
      getRequestsByType,
      getRequestsByStatus,
      getPipelineStages,
      getAuditByType,
      getPeakHours,
      getTopUsers,
      getRecentActivity,
      getFiltersMeta,
      getActivityTimeline,
      getUsersWorkSummary,
      getRequestsByTypeTimeSeries,
      getRequestDurations,
      getPeakLoad,
      getErrorsRecent,
      getDowntime,
      getWorkOverview,
      getPendingAged,
      getDailyActivity,
      getSessionsDetail,
    }),
    [
      getOverview,
      getTimeSeries,
      getRequestsByType,
      getRequestsByStatus,
      getPipelineStages,
      getAuditByType,
      getPeakHours,
      getTopUsers,
      getRecentActivity,
      getFiltersMeta,
      getActivityTimeline,
      getUsersWorkSummary,
      getRequestsByTypeTimeSeries,
      getRequestDurations,
      getPeakLoad,
      getErrorsRecent,
      getDowntime,
      getWorkOverview,
      getPendingAged,
      getDailyActivity,
      getSessionsDetail,
    ]
  );
}
